import React, { FC, memo, ReactNode, useCallback, useMemo, useState } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { ReactComponent as DiscountIcon } from 'shared/assets/icons/DiscountIcon.svg';
import { ReactComponent as RentOptionIcon } from 'shared/assets/icons/RentOptionsIcon.svg';
import { TableFilterContextProvider } from 'features/TableFilter';
import { DiscountsTable } from './DiscountsTable';
import { TabSwitcher } from 'shared/ui/TabSwitcher';
import { RentOptionsTable } from './RentOptionsTable';

export const DiscountsPage: FC = memo(() => {
  const { t } = useAppTranslation(['contracts', 'common']);
  const [selectedTabKey, setSelectedTabKey] = useState('Discounts');

  const renderTabContent = useCallback((): Nullable<ReactNode> => {
    switch (selectedTabKey) {
      case 'Discounts':
        return (
          <TableFilterContextProvider>
            <DiscountsTable />
          </TableFilterContextProvider>
        );
      case 'Rent options':
        return (
          <TableFilterContextProvider>
            <RentOptionsTable />
          </TableFilterContextProvider>
        );

      default:
        return null;
    }
  }, [selectedTabKey]);

  const switchTab = useCallback((tabKey: string): void => {
    setSelectedTabKey(tabKey);
  }, []);

  const tabs = useMemo(() => {
    const commonTabs = [
      { key: 'Discounts', label: t('Discounts', { ns: 'contracts' }), icon: <DiscountIcon /> },
      { key: 'Rent options', label: t('Rent options', { ns: 'contracts' }), icon: <RentOptionIcon /> },
    ];

    return commonTabs;
  }, [t]);

  return (
    <>
      <TabSwitcher tabs={tabs} selectedTabKey={selectedTabKey} onChangeTab={switchTab}>
        {renderTabContent()}
      </TabSwitcher>
    </>
  );
});
